
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 464V48c0-8.837 7.163-16 16-16h240v64c0 17.673 14.327 32 32 32h64v48h32v-64a15.997 15.997 0 00-4.64-11.36l-96-96A16.001 16.001 0 00304 0H48C21.49 0 0 21.491 0 48v416c0 26.51 21.49 48 48 48h112v-32H48c-8.836 0-16-7.163-16-16zM480 320h-32v32h32v32h-64v-96h96c0-17.673-14.327-32-32-32h-64c-17.673 0-32 14.327-32 32v96c0 17.673 14.327 32 32 32h64c17.673 0 32-14.327 32-32v-32c0-17.673-14.327-32-32-32z"}}),_c('path',{attrs:{"d":"M304 256c-35.346 0-64 28.654-64 64v32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64v-32c0-35.346-28.654-64-64-64zm32 96c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-32c0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32v32zM160 256h-32v144c0 8.837 7.163 16 16 16h80v-32h-64V256z"}})])
          )
        }
      }
    